import React, { useState } from "react";
import * as S from "./BrandTrust.styles";
import { IIndustryTypeItem, IndustryType } from "./BrandTrust.types";
import { customerData } from "./BrandTrust.data";
import { useTabAutoplay } from "hooks/useTabAutoplay";
import { useTranslation } from "hooks/useTranslation";
import { INDUSTRY_TYPE_CONFIG } from "./BrandTrust.config";
import { MicrositeHeading } from "pages/LayoutComponents/MicrositeHeading";

export const BrandTrust = () => {
  const { t } = useTranslation();

  const [selectedIndustry, setSelectedIndustry] = useState<IIndustryTypeItem>(
    INDUSTRY_TYPE_CONFIG[0],
  );

  useTabAutoplay({
    activeTab: selectedIndustry,
    sections: INDUSTRY_TYPE_CONFIG,
    setActiveTab: setSelectedIndustry,
  });

  return (
    <S.Wrapper>
      <MicrositeHeading
        title={t("landing.brandTrust.header")}
        isCentered
        isMainTitle
        spacing={{ top: 0, bottom: 24 }}
      />

      <S.BrandTrustContainer>
        <S.IndustrySelectorWrapper>
          <S.TabScrollContainer
            direction="horizontal"
            align="left"
            scrollStepType="itemWidth"
            arrowFadeColor="rgba(255, 255, 255, 0.6)"
            alignActive="center"
            hideArrows
            enableWheelScroll
            gap={0}
            activeIndex={selectedIndustry?.index}
            items={INDUSTRY_TYPE_CONFIG.map((tab) => ({
              id: String(tab.id),
              key: tab.id,
              render: () => (
                <S.Tab
                  $isActive={tab.id === selectedIndustry?.id}
                  onClick={() => {
                    setSelectedIndustry(tab);
                  }}
                >
                  {t(tab.label)}
                </S.Tab>
              ),
            }))}
          />
        </S.IndustrySelectorWrapper>

        <S.LogoContainer>
          {customerData.map((data) => (
            <S.LogoBox
              key={data.name}
              $fadeOut={
                selectedIndustry?.id !== IndustryType.All &&
                data.industryType !== selectedIndustry?.id
              }
            >
              <S.BrandTrustLogo
                loading="lazy"
                decoding="async"
                src={data.logo}
                alt={data.name}
              />
            </S.LogoBox>
          ))}
        </S.LogoContainer>
      </S.BrandTrustContainer>
    </S.Wrapper>
  );
};
